// A MENSAGEM AINDA NÃO SAIU (20/10/2026, "desfazer envio" no WhatsApp oficial — Advup::Wame::DesfazerEnvio).
// O servidor marca `segurada_ate`; enquanto não passar, nem a mensagem tiver sido liberada ou desfeita, ela espera.
// Uma regra só para a bolha (esmaecida) e para o cartão do "Desfazer" (contagem e anel).
import { computed, onBeforeUnmount, ref, watch } from 'vue';

const ESPERA_MS = 10000;

export function useEnvioSegurado(contentAttributes) {
  const agora = ref(Date.now());
  let relogio = null;

  const atributo = chave => {
    const camel = chave.replace(/_([a-z])/g, (_, letra) => letra.toUpperCase());
    const atributos = contentAttributes.value || {};
    return atributos[camel] ?? atributos[chave];
  };

  const ate = computed(() => {
    const valor = atributo('segurada_ate');
    return valor ? new Date(valor).getTime() : null;
  });

  const encerrada = computed(
    () =>
      !!atributo('liberada_em') ||
      !!atributo('envio_desfeito') ||
      !!(contentAttributes.value || {}).deleted
  );

  const restanteMs = computed(() =>
    ate.value ? Math.max(0, ate.value - agora.value) : 0
  );

  const emEspera = computed(() => !encerrada.value && restanteMs.value > 0);
  const segundos = computed(() => Math.ceil(restanteMs.value / 1000));
  // 1 = acabou de sair da caixa de texto; 0 = vai sair agora.
  const fracao = computed(() =>
    Math.min(1, Math.max(0, restanteMs.value / ESPERA_MS))
  );

  const parar = () => {
    if (relogio) clearInterval(relogio);
    relogio = null;
  };

  watch(
    () => !!ate.value && !encerrada.value,
    contando => {
      if (contando && !relogio) {
        agora.value = Date.now();
        relogio = setInterval(() => {
          agora.value = Date.now();
          if (restanteMs.value <= 0) parar();
        }, 100);
      }
      if (!contando) parar();
    },
    { immediate: true }
  );

  onBeforeUnmount(parar);

  return { emEspera, segundos, fracao };
}
